import React from "react";

import { makeStyles, Theme } from "@material-ui/core/styles";
import { IRequestCalloutDTO } from "../calloutRequested/types/IRequestCalloutDTOs";
import clsx from "clsx";
import { ICalloutActions } from "./types/calloutResponseTypes";
import { getButtonNameForDirver } from "./calloutResponseHelpers";
import CalloutStatuses from "../types/CalloutStatuses";

interface CalloutButtonForDriverProps {
  row: IRequestCalloutDTO;
  calloutActions: ICalloutActions;
  isMyVehicle: boolean;
  activeRequestCalloutId: string | null;
}

const elementWidth = 210;

const useStyles = makeStyles<Theme>((theme) => ({
  button: {
    borderWidth: 0,
    // padding: "6px 16px",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "lato",
    borderRadius: 6,
    marginLeft: 5,
    cursor: "pointer",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: elementWidth,
    height: 42,
    marginTop: 5,
    marginBottom: 5,
  },
  buttonContainer: {
    "@media (max-width: 1280px)": {
      display: "flex",
      justifyContent: "center",
    },
  },
  myVehicleButton: {
    backgroundColor: "#F4B827",
    color: "#03090E",

    "@media (max-width: 1280px)": {
      width: "110px",
    },
  },
  myVehicleDisabledButton: {
    backgroundColor: "#F4B827",
    color: "#474a2d",
    opacity: 0.5,
  },
  labelStatus: {
    fontSize: 18,
    fontWeight: 400,
    fontFamily: "lato",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: elementWidth,

    "@media (max-width: 1280px)": {
      display: "flex",
      justifyContent: "center",
      width: "110px",
    },
  },
  anotherVehicleButton: {
    backgroundColor: "#002047",
    color: "#F4B827",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "rgba(255, 255, 255, 0.27)",
  },
}));

const isButtonDisabled = (row: IRequestCalloutDTO, isMyVehicle: boolean, activeRequestCalloutId: string | null): boolean => {
  const status = row.status ?? 0;

  if (isMyVehicle && activeRequestCalloutId && activeRequestCalloutId !== row.requestCalloutId && status > CalloutStatuses.dispatchedToTeam) return true;

  if (!isMyVehicle && status > CalloutStatuses.teamAcknowledged) return true;

  return false;
};

const CalloutButtonForDriver: React.FC<CalloutButtonForDriverProps> = ({ row, calloutActions, isMyVehicle, activeRequestCalloutId }) => {
  const classes = useStyles();
  if (!row.status) return null;
  const status = row.status ?? 0;

  const disabled = isButtonDisabled(row, isMyVehicle, activeRequestCalloutId);

  if (disabled && !isMyVehicle) {
    return (
      <div className={classes.buttonContainer}>
        <div className={classes.labelStatus}>{getButtonNameForDirver(status, isMyVehicle)}</div>
      </div>
    );
  }

  let buttonClass = "";
  if (isMyVehicle && disabled) {
    buttonClass = clsx(classes.button, classes.myVehicleDisabledButton);
  } else if (isMyVehicle || status === CalloutStatuses.dispatchedToTeam) {
    buttonClass = clsx(classes.button, classes.myVehicleButton);
  } else if (!isMyVehicle && status === CalloutStatuses.teamAcknowledged) {
    buttonClass = clsx(classes.button, classes.anotherVehicleButton);
  }

  const onClickAction = () => {
    if (status === CalloutStatuses.dispatchedToTeam || (!isMyVehicle && status === CalloutStatuses.teamAcknowledged)) {
      calloutActions.assignCalloutRequestToUser(row.requestCalloutId);
    } else if (status > CalloutStatuses.dispatchedToTeam && status < CalloutStatuses.teamDeparted) {
      calloutActions.updateRequestCallout(row.requestCalloutId, status + 1);
    }
  };

  return (
    <div className={classes.buttonContainer}>
      <button className={buttonClass} onClick={onClickAction} disabled={disabled}>
        {getButtonNameForDirver(status, isMyVehicle)}
      </button>
    </div>
  );
};

export default CalloutButtonForDriver;
